import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toolSchema } from "./schema";
import { fetchToolData } from "./read";
import { useUpdateTool } from "../update/mutation";
import { useCreateTool } from "../create/mutation";

export const useToolForm = ({ toolId }) => {
  const form = useForm({
    resolver: zodResolver(toolSchema),
    defaultValues: {
      name: "",
    },
  });

  const updateTool = useUpdateTool();
  const createTool = useCreateTool();

  const handleCreate = async (context) => {
    const item = context.values;
    await createTool.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateTool.mutateAsync({ toolId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchToolData({ toolId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
